import React, { useRef } from 'react';

import classNames from 'classnames';

import './TableCell.scoped.scss';
import { DateTime } from 'luxon';

import { TeacherGetAttendancesQuery } from '@school_ify/schoolify-repository/src/teacher/types';

import { ReactComponent as AbsentIcon } from 'assets/icons/attendance_absent.svg';
import { ReactComponent as LateIcon } from 'assets/icons/attendance_late.svg';
import { ReactComponent as ExemptIcon } from 'assets/icons/attendance_exempt.svg';
import { ReactComponent as RemarkIcon } from 'assets/icons/attendance_remark.svg';
import StyledTooltip from 'components/StyledTooltip/StyledTooltip';

import Details from './partials/Details/Details';

interface Props {
  id: string;
  date: string;
  attendance?: TeacherGetAttendancesQuery['attendances'][0];
  setPopoverOpened: React.Dispatch<React.SetStateAction<string>>;
  classTitle: string;
  subjectTitle: string;
  attendances: TeacherGetAttendancesQuery['attendances'];
  classId: string;
  semesterId: string;
  studentId: string;
  subjectId: string;
  refetchAttendances: () => void;
  detailsOpened: boolean;
}

const GradesTableGradeCell: React.FC<Props> = ({
  id,
  date,
  attendance,
  detailsOpened,
  setPopoverOpened,
  classTitle,
  subjectTitle,
  attendances,
  classId,
  semesterId,
  subjectId,
  studentId,
  refetchAttendances,
}) => {
  const rootNode = useRef(null);

  const handleClick = () => {
    setPopoverOpened(id);
  };

  const icons = {
    absent: <AbsentIcon />,
    late: <LateIcon />,
    exempt: <ExemptIcon />,
    remark: <RemarkIcon />,
  };

  const attendanceItems = attendances.filter(item => {
    const dateStr = DateTime.fromISO(item.date).toFormat('y-MM-dd');
    return date === dateStr && item.subject_id === subjectId && studentId === item.student_id;
  });

  return (
    <td
      className={classNames({ 'grades-table-grade-cell': true, details: detailsOpened })}
      onClick={handleClick}
    >
      <div ref={rootNode} className={classNames({ content: true })}>
        {attendance && (
          <StyledTooltip
            key={attendance?.type?.text || Math.random()}
            direction="up"
            tagName="div"
            content={<p>{attendance?.type?.text}</p>}
          >
            {icons[attendance?.type?.icon]}
          </StyledTooltip>
        )}
      </div>

      {detailsOpened && (
        <Details
          date={date}
          classTitle={classTitle}
          subjectTitle={subjectTitle}
          attendance={attendance}
          attendanceItems={attendanceItems}
          classId={classId}
          semesterId={semesterId}
          subjectId={subjectId}
          studentId={studentId}
          refetchAttendances={refetchAttendances}
          onClose={() => {
            setPopoverOpened('');
          }}
          rootNode={rootNode}
        />
      )}
    </td>
  );
};

export default React.memo(GradesTableGradeCell);
